import { useI18n } from '../../../i18n'
import styles from '../../../styles/enterprise/EnterpriseOperationalUx.module.scss'

type Props = {
  storytelling: string | null
  explanations?: string[]
}

export default function OperationalStorytellingPanel({ storytelling, explanations = [] }: Props) {
  const { t } = useI18n()
  const lines = [
    ...(storytelling ? [storytelling] : []),
    ...explanations.filter((x) => x && x !== storytelling),
  ].slice(0, 4)

  if (!lines.length) {
    return (
      <p className={styles.emptyState}>
        {t('enterpriseOperationalUx.context.noInstability', 'No certification instability detected')}
      </p>
    )
  }

  return (
    <div>
      <p className={styles.postureMetricLabel}>
        {t('enterpriseOperationalUx.context.operationalInstability', 'Operational instability')}
      </p>
      {lines.map((line) => (
        <p key={line} className={styles.postureStory}>
          {line}
        </p>
      ))}
    </div>
  )
}
